<div class="error-container" role="alert">
  @if (errors.missingLti1p3Deployment.missing_deployment.is_migration) {
    <span
      translate="missing-deployment-error-renderer-existing-lms">
    </span>
  }
  @if (!errors.missingLti1p3Deployment.missing_deployment.is_migration) {
    <span
      translate="missing-deployment-error-renderer-new-lms">
    </span>
  }
</div>
@if (setupInstructionsLink) {
  <a
    href="{{setupInstructionsLink}}"
    target="_blank"
    class="primary-btn stacked-item"
    translate="error-renderer-view-setup-instructions">
  </a>
}
<a
  href="{{contactSupport}}"
  target="_blank"
  class="tertiary-btn stacked-item"
  translate="error-renderer-contact-support">
</a>
